import MDN from '../../images/mdnLogo.png';
import Clippy from '../../images/clippy.png';
import Easings from '../../images/easings.png';
import Codrops from '../../images/codrops.png';
import Pexels from '../../images/pexels.png';
import Unsplash from '../../images/unsplash.png';

const data = [
    {
        id: 111,
        category: "javascript",
        title: "JavaScript Reference by MDN",
        link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference",
        image: MDN,
        name: "Mdn",
        desc: "A JavaScript reference by MDN."
    },
    {
        id: 112,
        category: "javascript",
        title: "JavaScript Operator precedence",
        link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Operator_Precedence",
        image: MDN,
        name: "Mdn",
        desc: "A cheatsheet to determine which JavaScript operators are evaluated first.."
    },
    {
        id: 113,
        category: "javascript",
        title: "JavaScript Event reference",
        link: "https://developer.mozilla.org/en-US/docs/Web/Events",
        image: MDN,
        name: "Mdn",
        desc: "A reference list of all DOM events with explanations."
    },
    {
        id: 114,
        category: "css",
        title: "CSS Reference by MDN",
        link: "https://developer.mozilla.org/en-US/docs/Web/CSS/Reference",
        image: MDN,
        name: "Mdn",
        desc: "Use this reference to help you with CSS properties."
    },
    {
        id: 115,
        category: "css",
        title: "Clippy",
        link: "https://bennettfeely.com/clippy/",
        image: Clippy,
        name: "Clippy",
        desc: "A tool to help you using clip-path property"
    },
    {
        id: 116,
        category: "css",
        title: "CSS Easing Functions",
        link: "https://easings.net/",
        image: Easings,
        name: "Easings",
        desc: "Easing functions for transitions and animations."
    },
    {
        id: 117,
        category: "css",
        title: "CSS Reference by Codrops",
        link: "http://tympanus.net/codrops/css_reference/",
        image: Codrops,
        name: "Codrops",
        desc: "Another reference to help you with CSS properties"
    },
    {
        id: 118,
        category: "images",
        title: "Unsplash",
        link: "https://unsplash.com",
        image: Unsplash,
        name: "Unsplash",
        desc: "Great place for free images, with a simple API."
    },
    {
        id: 119,
        category: "videos",
        title: "Pexels",
        link: "https://www.pexels.com/videos",
        image: Pexels,
        name: "Pexels",
        desc: "Great free short videos."
    },
    {
        id: 120,
        category: "images",
        title: "Pexels",
        link: "https://www.pexels.com",
        image: Pexels,
        name: "Pexels",
        desc: "Great free images."
    }
];

export default data;